import { SSOAPIBaseError } from './sso-api-base-error';

export class SSOAPINetworkError extends SSOAPIBaseError {}
